<section class="col-xs-12 col-sm-12 credits_titlesection">

  <div class="col-xs-12 col-sm-12 col-md-7 col-lg-8">
    <div class="credits_header">{{"financialDashboard.creditstitle" | cxTranslate}}</div>
    <div class="credits_dropdown">
      @if (dropdownDetail) {
        <select id="credits_dropdownselect" (change)="selectedSeason($event)" [(ngModel)]="finalSeason">
          @for (obj of dropdownDetail.seqirusSeasonList; track obj; let i = $index) {
            <option  [value]="obj" id="credits_dropdownselect-{{i}}"> {{"financialDashboard.viewseason" | cxTranslate}}{{obj.replace('-20','/')}} </option>
          }
        </select>
      }
    </div>
  </div>
</section>
